/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import ForcJournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import ConsultationReportWrittenJournalEvent from "core/models/consultation-report-written-journal-event";
import ConsultationReportWrittenQuestion from "core/models/consultation/consultation-report-written-question";
import Patient from "core/models/patient";
import ConfigurationService, { Configuration } from "core/services/configuration";
import IntlService from "ember-intl/services/intl";
let ConsultationReportFormContentComponent = (_class = class ConsultationReportFormContentComponent extends Component {
  get patient() {
    return this.args.patient;
  }
  constructor(owner, args) {
    super(owner, args);
    // It is needed to update the questions
    // when the changeset is updated after draft loading
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "configuration", _descriptor3, this);
    _initializerDefineProperty(this, "questions", _descriptor4, this);
    args.forcComponent.afterLoad = () => {
      this.onConsultationTypeChange();
    };
  }
  get consultationType() {
    return this.args.forcComponent.changeset.get("consultationType");
  }
  get displayPPSActionsDropdown() {
    if (this.args.forcComponent.args.patient.followUpReasonRecord?.therapeuticalArea.id != "mental") return false;
    return this.consultationType?.startsWith("Point de suivi récurrent Case Manager");
  }
  onQuestionInput() {
    this.args.onUpdateQuestion?.();
  }
  async onConsultationTypeChange() {
    if (this.consultationType == "Accompagnement thérapeutique") {
      this.args.forcComponent.changeset.set("consultationType", null);
      this.router.transitionTo(this.router.currentRouteName, {
        queryParams: {
          tab: "write-therapeutic-assistance"
        }
      });
    } else {
      if (this.consultationType == undefined) {
        this.args.setCurrentQuestions?.([]);
      } else {
        // User can only fill questions
        // we indicated in ConsultationReportWrittenJournalEvent.getQuestions
        if (this.args.forcComponent.isNewMode) {
          const defaultQuestions = ConsultationReportWrittenJournalEvent.getQuestions(this.consultationType);
          this.args.setCurrentQuestions?.(defaultQuestions);
          // This is needed, otherwise changeset is recomputed when typing the first answer
          // of the first question, and we lose the focus from the textarea
          this.updateQuestionsFromChangeset(defaultQuestions.map(defaultQuestion => {
            return {
              question: defaultQuestion,
              answer: defaultQuestion.answer
            };
          }), false);
        }
        // If the user is editing the JE
        // it may want to see old questions that
        // are not provided anymore
        else {
          this.args.setCurrentQuestions(this.args.forcComponent.model.questions);
        }
      }
    }
  }
  get consultationTypesFromFrequencies() {
    const consultationFrequencies = this.configuration.configurationForPatient(Configuration.Consultation, this.patient).consultationFrequencies || [];
    return consultationFrequencies.filter(type => type.enabled).map(type => type.id);
  }
  get consultationTypes() {
    const consultationReportTypes = this.configuration.configurationForPatient(Configuration.Consultation, this.patient).consultationReportTypes || [];
    const filteredReportTypes = consultationReportTypes.filter(reportType => reportType.enabled);
    return filteredReportTypes.map(type => {
      return this.intl.t(`consultation-report-types.${type.id}`);
    });
  }

  // As the `questions` property of the changeset is an array,
  // we have to manage it on our own
  updateQuestionsFromChangeset(questionsWithAnswer, replace = true) {
    const changesetQuestions = Object.values(Object.assign({}, this.args.forcComponent.changeset.get("questions")));
    questionsWithAnswer.forEach(questionWithAnswer => {
      const questionToUpdate = changesetQuestions.find(question => question.key == questionWithAnswer.question.key);
      if (questionToUpdate && replace) {
        questionToUpdate.answer = questionWithAnswer.answer;
      } else {
        if (!questionToUpdate) {
          changesetQuestions.push({
            key: questionWithAnswer.question.key,
            issue: questionWithAnswer.question.issue,
            answer: questionWithAnswer.answer
          });
        }
      }
    });
    this.args.forcComponent.changeset.set("questions", changesetQuestions);
  }
  updateQuestion(question, event) {
    this.updateQuestionsFromChangeset([{
      question,
      answer: event.target.value
    }]);
    this.args.onUpdateQuestion?.();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "configuration", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "questions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onQuestionInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onQuestionInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConsultationTypeChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onConsultationTypeChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateQuestionsFromChangeset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateQuestionsFromChangeset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateQuestion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateQuestion"), _class.prototype), _class);
export { ConsultationReportFormContentComponent as default };